<!-- 交付在线 - 首页 - 弹框 lzj -->
<template>
    <div class="popup_wrap" v-if="show" @click="close">
        <div v-if="type == 0" class="popup popup_box" @click.stop="()=>{}">
            <div class="close" @click="close">关闭</div>
            <div class="msg" v-html="msg"></div>
            <div class="btn" @click="goUrl">{{ btnText }}</div>
        </div>
        <div v-if="type == 1" class="popup popup_box2" @click.stop="()=>{}">
            <div class="close" @click="close">关闭</div>
            <div class="msg">{{ msg }}</div>
            <div class="hint">已生成</div>
            <div class="btn" @click="goUrl">立即查看</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LookPopup",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        type: {
            type: Number,
            default: -1, // 0 - 中心， 1 - 底部
        },
        msg: {
            type: String,
            default: '',
        },
        btnText:{
            type: String,
            default: '前往验收',
        },
        url: {
            type: String,
            default: '',
        }
    },
    data() {
        return {};
    },
    methods: {
        close() {
            this.$emit('close')
        },
        goUrl() {
            if (this.url) {
                this.$router.push({
                    path: this.url,
                    query:{
                        appmob: this.$route.query.appmob
                    }
                });
            } else {
                console.log('url无效')
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.popup_wrap {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
}

.popup {
    position: absolute;
    animation: pan 0.2s;

    .close {
        position: absolute;
        top: 0;
        right: 100px;

        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 28px;
    }
}

.popup_box {
    width: 750px;
    height: 702px;
    background-image: url('~@/assets/images/user/housev2/popup_bg.png');
    background-size: 100% 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .close {
        right: 64px;
    }

    .msg {
        font-size: 32px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 56px;
        width: 504px;
        margin: 274px auto 0;
        text-align: center;
    }

    .btn {
        width: 284px;
        height: 64px;
        background: #7AA894;
        border-radius: 32px;
        margin: 0 auto 148px;

        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: $whiteText;
        line-height: 64px;
        text-align: center;
    }
}

.popup_box2 {
    width: 726px;
    height: 382px;
    background-image: url('~@/assets/images/user/housev2/popup_bg2.png');
    background-size: 100% 100%;
    left: 50%;
    bottom: env(safe-area-inset-bottom);
    transform: translateX(-50%);

    .msg {
        font-size: 40px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: bold;
        color: $blackText;
        line-height: 40px;
        letter-spacing: 1px;
        margin: 100px auto 0 132px;
        position: relative;
    }

    .msg::after {
        content: "";
        position: absolute;
        top: 0;
        left: -32px;
        width: 16px;
        height: 40px;
        background: #0D53FC;
        border-radius: 4px;
    }

    .hint {
        font-size: 32px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        color: $blackText;
        line-height: 48px;
        margin: 16px auto 0 132px;

    }

    .btn {
        width: 180px;
        height: 64px;
        background: #7AA894;
        border-radius: 32px;
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 64px;
        margin: 32px auto 0 100px;

    }
}

@keyframes pan {
    0% {
        left: 100%;
    }
    100% {
        left: 50%;
    }
}
</style>
